/**
 * 全角の数字・記号を半角に変換する
 */
export function toHalfWidthDigits(value: string): string {
  return value.replace(/[！-～]/g, (char) =>
    String.fromCharCode(char.charCodeAt(0) - 0xfee0),
  );
}

/**
 * 数字・小数点以外を除去したテキストを返す（表示用）。
 * 小数点は最初の1つのみ残し、それ以降は除去する（"12."のように入力途中の状態も許容する）
 */
export function cleanNumericText(rawValue: string): string {
  const digitsAndDots = toHalfWidthDigits(rawValue).replace(/[^0-9.]/g, '');
  const firstDotIndex = digitsAndDots.indexOf('.');
  if (firstDotIndex === -1) {
    return digitsAndDots;
  }
  const integerPart = digitsAndDots.slice(0, firstDotIndex);
  const decimalPart = digitsAndDots.slice(firstDotIndex + 1).replace(/\./g, '');
  return `${integerPart}.${decimalPart}`;
}

export function parseNumericText(cleanedText: string): number | null {
  if (cleanedText === '' || cleanedText === '.') {
    return null;
  }
  const parsed = Number(cleanedText);
  return Number.isNaN(parsed) ? null : parsed;
}

/**
 * type="number"は不正な入力（全角文字等）時にDOMのvalueが空文字化され、値が丸ごとクリアされてしまうため
 * type="text" 化している。ngModel/formControlの自動同期には頼らず、input イベントのたびにDOM側の値も
 * 直接サニタイズ後のテキストへ書き戻す。
 * @returns サニタイズ後のテキストをパースした数値（呼び出し側でモデルへ反映する）
 */
export function applyNumericInputSanitization(event: Event): number | null {
  const inputElement = event.target as HTMLInputElement;
  const cleanedText = cleanNumericText(inputElement.value);
  if (inputElement.value !== cleanedText) {
    inputElement.value = cleanedText;
  }
  return parseNumericText(cleanedText);
}
